import throttle from 'lodash.throttle';

import { getItem, setItem } from '../storage';
import { getClientId } from '../client';

export const loadState = (key) => {
    try {
        const serializedState = getItem(key);
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        console.warn('Failed to load state', err);
        return undefined;
    }
};

export const saveState = (key, state) => {
    try {
        const serializedState = JSON.stringify(state);
        setItem(key, serializedState);
    } catch (err) {
        console.warn('Failed to save state', err);
    }
};

// `throttle` makes sure this function never gets run more often than twice a second.
export const saveStateThrottle = throttle((key, state) => { saveState(key, state); }, 500);

export const getProactiveMessageStorageKey = () => `${getClientId()}::bb-proactive-message-state`;

